<template>
    <b-skeleton-wrapper
        :loading="loading"
    >
        <template #loading>
            <b-card class="mt-2">
                <div class="text-center">
                    <b-spinner variant="primary"></b-spinner>
                </div>
            </b-card>
        </template>
        <b-card
            class="mt-2"
            :title="'Request to join ' + group.group_name + '?'"
            sub-title="Once approved to join, you'll receive an email notification. Then, you'll be able to sign-in."
        >
            <div class="text-center mt-3">
                <h3 v-if="orgUserRequested">
                    <font-awesome-icon icon="user-clock" class="mr-2"></font-awesome-icon>
                    Request Pending
                </h3>
                <button
                    v-else
                    class="sc-btn sc-btn-lg pill"
                    @click="createJoinRequest()"
                    :disabled="working"
                >
                    <b-spinner v-if="working" class="mr-2" />
                    <font-awesome-icon v-else icon="user-clock" class="mr-2" />
                    Request Access
                </button>
            </div>
        </b-card>
    </b-skeleton-wrapper>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            orgUserRequested: false,
            loading:          true,
            working:          false
        };
    },
    mounted() {
        this.checkUserRequest();
    },
    methods: {
        checkUserRequest() {
            this.loading = true;
            this.$api.get(
                "/api/group/request/status"
            ).then(({ data }) => {
                console.log(data);
                this.orgUserRequested = data.orgUserRequested;
                this.loading          = false;
            });
        },
        createJoinRequest() {
            this.working = true;
            this.$api.post(
                "/api/group/request",
                {
                    site: window.location.hostname
                }
            ).then(({ data }) => {
                this.orgUserRequested = data.orgUserRequested;
                this.working          = false;
            });
        }
    },
    computed: mapState(["group"])
}
</script>